
import {Component} from './base';
import {Moment} from 'moment';
import * as moment from 'moment';


export class PanelCalendarComponent extends Component {
  private eventId: number;
  private ajaxUrl: string;

  private editDateId: number | null = null;

  private events: JQuery.Event[] = [];

  public static shouldLoad() {
    return $('.panel-calendar').length > 0;
  }

  public load() {
    // Gather facts.
    this.eventId = parseInt($('#hidden-eventid').val() as string);
    this.ajaxUrl = $('#hidden-ajaxurl').val() as string;

    // Init calendar
    this.initCalendar();
  }

  public reload() {
    $('.panel-calendar').fullCalendar('refetchEvents');
  }

  public initCalendar() {
    $('.panel-calendar').fullCalendar({
      timezone: 'local',
      firstDay: 1,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      eventLimit: false,
      events: {
        url: this.ajaxUrl,
        data: {},
        error: () => {
          // todo
        },
      },
      timeFormat: 'H:mm',
      dayClick: (date: any) => {
        this.addDatePopup(date as Moment);
      },
      eventClick: (calendarEvent: any) => {
        this.editDatePopup(calendarEvent);
      }
    });

    // Init modal.
    $('#add-date-modal, #edit-date-modal').modal({
      backdrop: 'static',
      keyboard: false,
      show: false,
    });

    $('#add-date-cancel').click(() => {this.cancelDatePopup()});
    $('#add-date-submit').click(() => {this.submitDatePopup()});
    $('#edit-date-remove').click(() => {this.removeEditDatePopup()});
    $('#edit-date-cancel').click(() => {this.cancelEditDatePopup()});

    // Listen on the from changes.
    $('#add-date-datetimepicker-from').on('dp.change', (event) => {
      if (! event || ! event.date || ! event.oldDate) {
        return;
      }
      const date: Moment = event.date;
      const oldDate: Moment | boolean = event.oldDate;

      // Apply this difference to the until picker as well.
      if (oldDate !== false) {
        const diff = (date as Moment).diff(oldDate as Moment);
        const untilPicker = $('#add-date-datetimepicker-until').data('DateTimePicker');
        untilPicker.date(untilPicker.date().add(diff));
      }
    });
  }

  private async submitDatePopup() {
    // Validate and parse.
    const fromPicker = $('#add-date-datetimepicker-from').data('DateTimePicker');
    const untilPicker = $('#add-date-datetimepicker-until').data('DateTimePicker');
    const description = $('#add-date-description').val() as string;

    if (fromPicker.date().isAfter(untilPicker.date())) {
      alert('The until time must be after the begin time!');
      return;
    }
    if (fromPicker.date().isSame(untilPicker.date())) {
      alert('The until time must be different than the begin time. Please estimate the total duration of the event!');
      return;
    }

    // Send to server.
    const eventPayload = await this.saveEventDate(
      fromPicker.date(), untilPicker.date(), description ? description : null
    );

    if (! eventPayload) {
      return;
    }

    // Add to calendar view.
    $('.panel-calendar').fullCalendar('renderEvent', {
      title: $('#hidden-eventname').val() as string,
      start: fromPicker.date(),
      end: untilPicker.date(),
      id: eventPayload.id,
      description: eventPayload.description,
    }, false);

    // Close model.
    $('#add-date-modal').modal('hide');
  }

  private async removeEditDatePopup() {
    const dateId = this.editDateId;

    // Send remove request to server.
    const success = await this.removeEventDate(dateId as number);

    if (success) {
      $('.panel-calendar').fullCalendar('removeEvents', [dateId]);
    }
    $('#edit-date-modal').modal('hide');
  }

  private cancelEditDatePopup() {
    // Hide modal & clear state.
    $('#edit-date-modal').modal('hide');
    this.editDateId = null;
  }

  private cancelDatePopup() {
    // Hide modal.
    $('#add-date-modal').modal('hide');
  }

  private async saveEventDate(start: Moment, until: Moment, description: string | null) {
    try {
      const result = await $.ajax({
        type: 'POST',
        url: this.ajaxUrl,
        data: JSON.stringify({
          start: start.toISOString(),
          until: until.toISOString(),
          description: description
        }),
        contentType: 'application/json',
        dataType: 'json'
      });

      return result;
    } catch (error) {
      alert('Error while creating date: ' + error);
      console.error(error);
    }

    return false;
  }

  private async removeEventDate(id: number) {
    try {
      const result = await $.ajax({
        type: 'DELETE',
        url: `${this.ajaxUrl}/${id}`,
        dataType: 'json'
      });
      return true;
    } catch (error) {
      alert('Error while deleting date: ' + error);
      console.error(error);
    }
    return false;
  }

  private editDatePopup(event: any) {
    this.editDateId = event.id;

    $('#edit-date-start').text(event.start.format('LLL'));
    $('#edit-date-description').text(event.description ? event.description : '- none -');

    $('#edit-date-modal').modal('show');
  }

  private addDatePopup(date: Moment) {
    // Convert UTC to local date.
    date = date.local();

    // Check if date >= now.
    const now = moment().startOf('day');
    if (date.isBefore(now)) {
      alert('You need to select a day in the future!');
      return;
    }

    // Show modal and ask for the time.
    $('#add-date-day').text(date.format('MMMM Do YYYY'));
    $('#add-date-datetimepicker-from, #add-date-datetimepicker-until').datetimepicker({
      inline: true,
      format: 'LT', // Only ask for time!
      sideBySide: true,
    });

    // Clear description input
    $('#add-date-description').val('');

    // Set the time on the first picker.
    const fromPicker = $('#add-date-datetimepicker-from').data('DateTimePicker');
    fromPicker.enabledDates([date.clone()]);
    fromPicker.date(date.clone());

    // Add 1 hour to the until picker.
    const untilPicker = $('#add-date-datetimepicker-until').data('DateTimePicker');
    fromPicker.minDate(date.clone());
    untilPicker.date(date.clone().add(1, 'h'));

    $('#add-date-modal').modal('show');
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/panel-calendar.ts